module.exports = __webpack_public_path__ + "filetype-image.svg?64a2dd93a577e40354ab3cfc970bf7f7";